import execCommand from 'execcommand-copy';
import { useCallback } from 'react';

import Entities from 'STORE';

export function useCopyToClipboard(data: string, message: string, onCopy?: () => void): () => void {
  return useCallback(() => {
    onCopy?.();
    execCommand.copy(data);
    Entities.toast.show(message);
  }, [data]);
}
